import { type ReactNode, useRef, useState } from 'react'
import { StoryViewerContext, type StoryViewerTarget } from './StoryViewerContext'
import StoryViewerModal from './StoryViewerModal'

export interface StoryViewerProviderProps {
	children: ReactNode
}

export default function StoryViewerProvider({ children }: StoryViewerProviderProps) {
	const sessionIdRef = useRef(0)
	const [viewer, setViewer] = useState<{ sessionId: number; target: StoryViewerTarget }>()

	const handleOpen = (target: StoryViewerTarget) => {
		sessionIdRef.current += 1
		setViewer({ sessionId: sessionIdRef.current, target })
	}

	return (
		<StoryViewerContext
			value={{
				isStoryViewerOpen: Boolean(viewer),
				openStoryViewer: handleOpen,
			}}
		>
			{children}
			<StoryViewerModal
				target={viewer?.target}
				sessionId={viewer?.sessionId}
				onDismiss={() => setViewer(undefined)}
			/>
		</StoryViewerContext>
	)
}
